import { PROFILE_KEY } from '../../../../../models/profile/constants'
import { getActionStrReduxUtil } from '../../../../redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '../../../../redux/constants/action'
import { updateProfileAction } from '../../actions/update'

/**
 * @param value
 * @returns {(function(*, *): void)|*}
 */
export function updateDailyCarbsIntakeGoalPercentageProfileAction ({
  value
}) {
  return (dispatch) => {
    const key = PROFILE_KEY.DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL
    dispatch(
      updateProfileAction({
        type: getActionStrReduxUtil(
          REDUX_ACTION_PREFIX.UPDATE,
          key,
          value
        ),
        payload: {
          key,
          value
        }
      })
    )
  }
}
